import React from 'react';
import { Button } from 'antd';
import { Translate } from '@above-the-treeline/localization';
import { RegistrationTypes } from '../RegistrationEnums';
import './registrationModalLinks.less';

type RegistrationModalLinksProps = {
	setType: (type: string) => void;
	type: string;
};

export default function RegistrationModalLinks({
	setType,
	type,
}: RegistrationModalLinksProps): JSX.Element {
	const isLogInModal = type === RegistrationTypes.LogIn;

	const getLinkLabel = () => {
		switch (type) {
			case RegistrationTypes.SignUp:
				return <Translate id="already_have_an_edelweiss_acount" />;
			case RegistrationTypes.LogIn:
				return <Translate id="dont_have_an_edelweiss_account" />;
			default:
				return <Translate id="back_to" />;
		}
	};

	return (
		<>
			{isLogInModal &&
				Boolean(process.env.REACT_APP_DO_SHOW_PASSWORD_EDITOR) && (
					<div className="registration-modal-link">
						<Button
							onClick={() =>
								setType(RegistrationTypes.ForgotPassword)
							}>
							<Translate id="forgot_password" />
						</Button>
					</div>
				)}
			<div className="registration-modal-link">
				{getLinkLabel()}
				<Button
					style={{ padding: '0 5px' }}
					onClick={() =>
						setType(
							!isLogInModal
								? RegistrationTypes.LogIn
								: RegistrationTypes.SignUp,
						)
					}>
					<Translate id={!isLogInModal ? 'log_in' : 'sign_up'} />
				</Button>
			</div>
		</>
	);
}
